var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PlusIcon } from '@import/icons';
import useCashflowTemplateStore from '@modules/cashflow/cf-template/store/cf-template.store';
import usePublishTemplateMutate from '@modules/cashflow/cf-template/hooks/mutations/usePublishTemplateMutate';
import useDuplicateTemplateMutate from '@modules/cashflow/cf-template/hooks/mutations/useDuplicateTemplateMutate';
import { CF_TEMPLATE_URL } from '@src/routes/url';
import useCustomTranslation from '@libs/hooks/useCustomTranslation';
var useCashFlowTemplateController = function () {
    // ---------------------------------
    // State, Store, Hooks and Form Initialization
    // ---------------------------------
    var navigate = useNavigate();
    var setSearchFilter = useCashflowTemplateStore(function (state) { return state.setSearchFilter; });
    var t = useCustomTranslation();
    // ---------------------------------
    // Query & Mutation
    // ---------------------------------
    var publishMutate = usePublishTemplateMutate().mutate;
    var duplicateMutate = useDuplicateTemplateMutate().mutate;
    // ---------------------------------
    // Memo hooks
    // ---------------------------------
    var listBtns = useMemo(function () {
        var list = [
            _jsx(Button, { variant: 'contained', color: 'primary', size: 'medium', startIcon: _jsx(PlusIcon, {}), onClick: handleGoToCreateTemplate, children: t('L000111') })
            // <Button variant='contained' color='primary' size='medium' startIcon={<ImportIcon />}>
            //   Import template (.xlsx)
            // </Button>
        ];
        return list;
    }, [t]);
    // ---------------------------------
    // Functions
    // ---------------------------------
    var actions = function (type, data) {
        switch (type) {
            case 'detail':
                navigate(CF_TEMPLATE_URL + '/' + data.id);
                break;
            case 'edit':
                navigate(CF_TEMPLATE_URL + '/' + data.id + '/edit');
                break;
            case 'publish':
                publishMutate(String(data.id));
                break;
            case 'duplicate':
                duplicateMutate(data.id);
                break;
            default:
                break;
        }
    };
    /**
     * @description Handle pagination for table ( page, limit)
     *
     * @param page number
     * @param pageSize number
     *
     * @returns void
     */
    function handleChangePagination(page, pageSize) {
        setSearchFilter({
            page: page,
            pageSize: pageSize
        });
    }
    function handleGoToCreateTemplate() {
        navigate('create');
    }
    function handleSearch(data) {
        var date = data.date, id = data.id, rest = __rest(data, ["date", "id"]);
        setSearchFilter(__assign(__assign({}, rest), { id: id ? Number(id) : undefined, createdAtRangeStart: date[0], createdAtRangeEnd: date[1] }));
    }
    return {
        listBtns: listBtns,
        actions: actions,
        handleSearch: handleSearch,
        handleChangePagination: handleChangePagination
    };
};
export default useCashFlowTemplateController;
